"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventService = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Api = _interopRequireDefault(require("../Api"));
var _excluded = ["token"],
  _excluded2 = ["token", "condoId", "eventId"],
  _excluded3 = ["token", "passId"],
  _excluded4 = ["token", "eventId"],
  _excluded5 = ["token", "id"],
  _excluded6 = ["token"],
  _excluded7 = ["token"],
  _excluded8 = ["token"],
  _excluded9 = ["token"],
  _excluded10 = ["token"],
  _excluded11 = ["token", "id"],
  _excluded12 = ["token", "id"],
  _excluded13 = ["token"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var EventService = exports.EventService = /*#__PURE__*/(0, _createClass2["default"])(function EventService() {
  (0, _classCallCheck2["default"])(this, EventService);
});
(0, _defineProperty2["default"])(EventService, "list", function (_ref) {
  var token = _ref.token,
    params = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return _Api["default"].withAuth(token).get('event/listLast', {
    params: params
  });
});
(0, _defineProperty2["default"])(EventService, "get", function (_ref2) {
  var token = _ref2.token,
    condoId = _ref2.condoId,
    eventId = _ref2.eventId,
    params = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return _Api["default"].withAuth(token).get("event/".concat(condoId, "/").concat(eventId), {
    params: params
  });
});
(0, _defineProperty2["default"])(EventService, "getByPass", function (_ref3) {
  var token = _ref3.token,
    passId = _ref3.passId,
    params = (0, _objectWithoutProperties2["default"])(_ref3, _excluded3);
  return _Api["default"].withAuth(token).get("event/passId/".concat(passId), {
    params: params
  });
});
(0, _defineProperty2["default"])(EventService, "getByIdAndCondos", function (_ref4) {
  var token = _ref4.token,
    eventId = _ref4.eventId,
    params = (0, _objectWithoutProperties2["default"])(_ref4, _excluded4);
  return _Api["default"].withAuth(token).get("event/".concat(eventId), {
    params: params
  });
});
(0, _defineProperty2["default"])(EventService, "checkout", function (_ref5) {
  var token = _ref5.token,
    id = _ref5.id,
    params = (0, _objectWithoutProperties2["default"])(_ref5, _excluded5);
  return _Api["default"].withAuth(token).post("event/checkout", _objectSpread({}, params));
});
(0, _defineProperty2["default"])(EventService, "todaySummary", function (_ref6) {
  var token = _ref6.token,
    params = (0, _objectWithoutProperties2["default"])(_ref6, _excluded6);
  return _Api["default"].withAuth(token).get('event/todaySummary', {
    params: params
  });
});
(0, _defineProperty2["default"])(EventService, "visitorsAverage", function (_ref7) {
  var token = _ref7.token,
    params = (0, _objectWithoutProperties2["default"])(_ref7, _excluded7);
  return _Api["default"].withAuth(token).get('event/averageEntrances', {
    params: params
  });
});
(0, _defineProperty2["default"])(EventService, "emergency", function (_ref8) {
  var token = _ref8.token,
    params = (0, _objectWithoutProperties2["default"])(_ref8, _excluded8);
  return _Api["default"].withAuth(token).get('event/emergencySummary', {
    params: params
  });
});
(0, _defineProperty2["default"])(EventService, "weeklyMovement", function (_ref9) {
  var token = _ref9.token,
    params = (0, _objectWithoutProperties2["default"])(_ref9, _excluded9);
  return _Api["default"].withAuth(token).get('event/weeklyMovement', {
    params: params
  });
});
(0, _defineProperty2["default"])(EventService, "visitorsByUnit", function (_ref10) {
  var token = _ref10.token,
    params = (0, _objectWithoutProperties2["default"])(_ref10, _excluded10);
  return _Api["default"].withAuth(token).get('event/topUnits', {
    params: params
  });
});
(0, _defineProperty2["default"])(EventService, "reCheckinEvent", function (_ref11) {
  var token = _ref11.token,
    id = _ref11.id,
    params = (0, _objectWithoutProperties2["default"])(_ref11, _excluded11);
  return _Api["default"].withAuth(token).post("event/".concat(id, "/recheckin"), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(EventService, "visitorIdentifier", function (_ref12) {
  var token = _ref12.token,
    id = _ref12.id,
    params = (0, _objectWithoutProperties2["default"])(_ref12, _excluded12);
  return _Api["default"].withAuth(token).get("event/".concat(id, "/visitorIdentifier"), {
    params: params
  });
});
(0, _defineProperty2["default"])(EventService, "getGateEvents", function (_ref13) {
  var token = _ref13.token,
    params = (0, _objectWithoutProperties2["default"])(_ref13, _excluded13);
  return _Api["default"].withAuth(token).get("gate/event", {
    params: params
  });
});